angular.module('workflow.app')
  .filter 'ensureArray', () ->
    return ( maybeArray ) ->
      return if angular.isArray(maybeArray) then maybeArray else [maybeArray]
